export default {
  name: 'oBlock'
};
